
import { createStore } from 'vuex'

import attendance, { RESETATTENDANCE } from './modules/attendance'
import authentication from './modules/authentication'
import destinations, { RESETDESTINATIONS } from './modules/destinations'
import guilds, { RESETGUILDS } from './modules/guilds'
import localStorage from './modules/localStorage'
import lockouts, { RESETLOCKOUTS } from './modules/lockouts'
import members, { RESETMEMBERS } from './modules/members'
import properties, { RESETPROPERTIES } from './modules/properties'
import propreqsets, { RESETPROPREQSETS } from './modules/propreqsets'
import playerprops, { RESETPLAYERPROPS } from './modules/playerprops'
import raidevents, { RESETRAIDEVENTS } from './modules/raidevents'
import raidHelper from './modules/raidHelper'
import signups, { RESETSIGNUPS } from './modules/signups'
import teams, { RESETTEAMS } from './modules/teams'
import charprops, { RESETCHARPROPS } from './modules/charprops'
import charaltnames, { RESETCHARALTNAMES } from './modules/charaltnames'

const store = createStore({
  strict: false, // Disable this on production environment for performance reasons

  modules: {
    attendance,
    authentication,
    charaltnames,
    charprops,
    destinations,
    guilds,
    localStorage,
    lockouts,
    members,
    playerprops,
    properties,
    propreqsets,
    raidevents,
    raidHelper,
    signups,
    teams,
  },

  state () {
    return {
    }
  },

  getters: {
  },

  mutations: {
  },

  actions: {
    resetState( { commit } ) {
      commit( RESETGUILDS )
      commit( RESETSIGNUPS )
      commit( RESETRAIDEVENTS )
      commit( RESETTEAMS )
      commit( RESETATTENDANCE )
      commit( RESETLOCKOUTS )
      commit( RESETDESTINATIONS )
      commit( RESETMEMBERS )
      commit( RESETPROPERTIES )
      commit( RESETPROPREQSETS )
      commit( RESETPLAYERPROPS )
      commit( RESETCHARPROPS )
      commit( RESETCHARALTNAMES )
    },
  },
})

export default store